module.exports = __webpack_public_path__ + "media/img/404-cat-1-439f4769.png";